import { Autocomplete,TextField } from "@mui/material"
import React from "react"
import { makeStyles } from "@material-ui/core/styles"
const AutocompleteCustom = ({ suggestions,value, onTextChange,onSelect, label,id, className,setvalue, sx, disableClearable}) => {
  const useStyles = makeStyles(() => ({
    root: {
      '& .MuiOutlinedInput-root': {
        '& fieldset': {
          borderColor: '#ff0f64',
          borderRadius: '15px',
          borderWidth: '2px',
        },
        '&:hover fieldset': {
          borderColor: '#ccc',
        },
        '&.Mui-focused fieldset': {
          borderColor: '#ccc',
        },
      },
      '& .MuiInputLabel-root': {
        color: '#999', // colore base della label
      },
      '& .MuiInputLabel-root.Mui-focused': {
        color: '#ff0f64', // colore della label in focus
      },
    },
  }));

  const classes = useStyles();
  return (
    <Autocomplete
        options={suggestions}
        noOptionsText="Nessun risultato"
        id={id}
        className={classes.root}
        value={value}
        onChange={(event, newValue) => {
            setvalue(newValue);
        }}
        disableClearable={disableClearable}
        onBlur={onSelect}
        sx={{...sx, width: '85%'}}
        renderInput={(params) => (
            <TextField  {...params} value={value} label={label} variant="outlined" onChange={(e)=>{typeof onTextChange === "function" ? onTextChange(e) : setvalue(e.target.value)}} />
        )}
    />
  )
}
export default AutocompleteCustom